export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.wixstatic.com/media/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg/v1/fill/w_1918,h_1080,q_90,enc_avif,quality_auto/28e51a_fb09017021e941b88dfe3d7c8c9b392b~mv2.jpg"
          alt="RidgeCap GC aerial drone roofing project"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d1a]/90 via-[#0d0d1a]/70 to-[#0d0d1a]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-32 flex flex-col lg:flex-row items-center gap-12">
        <div className="flex-1 text-left">
          <div className="inline-flex items-center gap-2 bg-[#f97316]/20 border border-[#f97316]/40 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
            <i className="ri-shield-check-line"></i>
            Insurance Claim Specialists
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
            Stop Leaving <span className="text-[#f97316]">Thousands</span> on the Table with Your Roof Claim
          </h1>
          <p className="text-white/75 text-lg md:text-xl leading-relaxed mb-8 max-w-xl">
            98% of homeowners never claim their full depreciation holdback. Most don&apos;t even know it exists. RidgeCap GC makes sure you get every dollar you&apos;re owed — and a roof built to last.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#cta"
              className="bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-8 py-4 rounded-md text-base whitespace-nowrap cursor-pointer transition-colors duration-200 text-center"
            >
              Get Your Free Claim Review
            </a>
            <a
              href="#holdback"
              className="border-2 border-white/50 hover:border-white text-white font-bold px-8 py-4 rounded-md text-base whitespace-nowrap cursor-pointer transition-colors duration-200 text-center"
            >
              Learn About Holdback Funds
            </a>
          </div>

          {/* Trust Stats */}
          <div className="flex flex-wrap gap-8 mt-12">
            {[
              { value: "$2.3M+", label: "Recovered for Homeowners" },
              { value: "500+", label: "Claims Maximized" },
              { value: "100%", label: "Warranty Compliant Installs" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-3xl font-black text-[#f97316]">{stat.value}</div>
                <div className="text-white/60 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Card */}
        <div className="hidden lg:block flex-shrink-0 w-80">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#f97316] rounded-full">
                <i className="ri-money-dollar-circle-line text-white text-xl"></i>
              </div>
              <div>
                <div className="text-white font-bold text-sm">Did You Know?</div>
                <div className="text-white/60 text-xs">Most homeowners miss this</div>
              </div>
            </div>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              Your insurance company holds back a portion of your claim — called <strong className="text-[#f97316]">recoverable depreciation</strong> — until repairs are completed. The average holdback is <strong className="text-white">$8,000–$15,000</strong>.
            </p>
            <div className="bg-[#f97316]/20 border border-[#f97316]/30 rounded-lg p-3 text-center">
              <div className="text-[#f97316] font-black text-2xl">98%</div>
              <div className="text-white/70 text-xs mt-1">of claims have unclaimed depreciation</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
